import React from 'react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const Team = () => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <section className="team">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Nossa Equipe</span>
          <h2 className="section-title">
            Profissionais <span className="gradient-text">experientes e dedicados</span>
          </h2>
        </div>
        <div className={`team-content ${isVisible ? 'scroll-animate in-view' : 'scroll-animate'}`} ref={ref}>
          <p>Nossa equipe é composta por desenvolvedores experientes, analistas de sistemas, consultores especializados e profissionais de diversas áreas da tecnologia, todos comprometidos em entregar soluções completas e inovadoras para nossos clientes.</p>
        </div>
      </div>
    </section>
  );
};

export default Team;

